
import React, { useState, useEffect, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "../../firebase-config";
import {db} from "../../firebase-config";
import {app} from "../../firebase-config";
import { async } from '@firebase/util';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import Cookies from 'universal-cookie';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {getAge} from "../../Helper";
import Moment from 'moment';
import Select from 'react-select';

const PlayerList = (props) => {
    const cookies = new Cookies();
    const playersCollectionRef = collection(db,"players");
    const [players,setPlayers] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const tableRef = useRef(null);
    const [selectedValue, setSelectedValue] = useState(cookies.get('selectedValue'));

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = () => {
      var workbook = XLSX.utils.book_new();
      var worksheet_data  = document.getElementById("mytable");
      var worksheet = XLSX.utils.table_to_sheet(worksheet_data);
      workbook.SheetNames.push("Test");
        workbook.Sheets["Test"] = worksheet;
      exportExcelFile(workbook);
    }
    function exportExcelFile(workbook) {
      return XLSX.writeFile(workbook, "bookName.xlsx");
    }

    useEffect(() => {
      // cookies.set('player', "", { path: '/' });
      if(cookies.get('selectedValue')==null){
        cookies.set('selectedValue', "1", { path: '/' });
        setSelectedValue("1");
      }
      getPlayers();
    }, [selectedValue]) 

    

    useEffect(()=>{
        if(isLoading){
            document.getElementById("data").style.display = "none";
            document.getElementById("loader").style.display = "block";
        }else{
            document.getElementById("data").style.display = "block";
            document.getElementById("loader").style.display = "none";
        }
    },[isLoading]);

    const searchPlayers = async (text) => {
      if(text.length<=0){
        getPlayers();
        return;
      }
      if(props.userHome.userData.main_user==="1"){
        const q = query(playersCollectionRef,where("club_id", "==",props.userHome.userData.club_id), where("name", ">=", text), where('name', '<=', text+ '\uf8ff'));
        const data = await getDocs(q);
        setPlayers(data.docs.map((doc)=> ({...doc.data(), id: doc.id})));
        console.log(data);
      }else{
        const q = query(playersCollectionRef,where("id", "==",props.userHome.userHome.uid), where("name", ">=", text), where('name', '<=', text+ '\uf8ff'));
        const data = await getDocs(q);
        setPlayers(data.docs.map((doc)=> ({...doc.data(), id: doc.id})));
        console.log(data);
      }
    }

    const getPlayers = async () => {
      var active_where = null;
      cookies.set('selectedValue', selectedValue, { path: '/' });
      if(selectedValue=="1"){
        active_where = where("active_program", "==","1");
      }else{
        active_where = where("active_program", "==","0");
      }

      if(props.userHome.userData.main_user==="1"){
        const q = query(playersCollectionRef,where("club_id", "==",props.userHome.userData.club_id),active_where);
        const data = await getDocs(q);
        setPlayers(data.docs.map((doc)=> ({...doc.data(), id: doc.id})))
      }else{
        const q = query(playersCollectionRef,where("id", "==",props.userHome.userHome.uid),active_where);
        const data = await getDocs(q);
        setPlayers(data.docs.map((doc)=> ({...doc.data(), id: doc.id})))
      }
      setLoading(false)
    }
    var rowCounter = 0;
    
    const options = [
      { value: '1', label: 'Active' },
      { value: '0', label: 'Deactives' },
    ]


    const handleChange = e => {
      setSelectedValue(e.value);
    }


    return (
      <>
        <h2>Registered Players</h2>
        <div className='row' id="data">
          <div className='row'>
            <div className='col-lg-1' style={{ display: "flex" }}>
              <button className='btn btn-primary btn-sm' style={{ marginLeft: "0px" }} onClick={() => {exportToCSV()}}>Export List</button>
            </div>
            <div className='col-lg-2' style={{ display: "flex" }}>
              <label>Search:</label>
              <input type="text" className='form-control form-inline' id="search" 
              onKeyPress={(event)=>{if(event.key == "Enter"){searchPlayers(document.getElementById("search").value)}}}></input>
            </div>
            <div className='col-lg-2' style={{ display: "flex" }}>
              <label>Status</label>
               <Select options={options}
                    placeholder="Select Option"
                    value={options.find(obj => obj.value === selectedValue)} 
                    onChange={handleChange}/>
            </div>
          </div>
          <div className='row' style={{overflowX: "scroll"}}>
            <div className='col-lg-12'>
              <br></br>
              <Table id="mytable" striped bordered hover ref={tableRef}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Birthdate</th>
                    <th>Age</th>
                    <th>Email</th>
                    <th>Active Program</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                {players.map((player) => {
                rowCounter++;
                return(
                    <tr key={player.id} style={{ backgroundColor: cookies.get('player')==player.id ? "MediumSeaGreen" : "white" }}>
                      <td>{rowCounter}</td>
                      <td>{player.name}</td>
                      <td>{Moment(player.birthdate?.toDate()).format('MM/DD/YYYY')}</td>
                      <td>{getAge(Moment(player.birthdate?.toDate()).format('MM/DD/YYYY'))}</td>
                      <td>{player.email}</td>
                      <td>{player.program_name}</td>
                      <td><button className='btn btn-primary btn-sm' onClick={() => {
                          cookies.set('player', player.id, { path: '/' });
                          props.updateStatePlayer(1,player.name,player);
                        }}>Open</button></td>
                    </tr>
                );
              })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div className="loader-container" id="loader">
            <div className="loader"></div>
        </div>
      </>
    )   
}

export default PlayerList;